import React, { Component } from "react";
import { store } from "../index";
import NumberFormat from "react-number-format";
import "../components/signup/signup.css";
import { hashHistory } from "react-router";
import {
  Form,
  Dropdown,
  Input,
  Button,
  Modal,
  Header,
  Icon
} from "semantic-ui-react";
import axios from "axios";

import { loginhandler } from "../actions/loginhandler";
class SignUp extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
      firstname: "",
      lasname: "",
      email: "",
      cellnum: "",
      homenum: "",
      worknum: "",
      gender: "",
      superstatus: false,
      supervisor: "",
      account: null,
      emaildomain: "@edfinc.com",
      discipline: [],
      profession: [],
      supercheck: " not ",
      empnumber: "",
      zipcode: "",
      address: "",
      middleinit: null,
      modalOpen: false
    };
  }

  grabInfo() {
    axios
      .get("http://23.31.37.220:8080/usersold", {
        params: {
          First_Name: this.state.firstname.toUpperCase(),
          Last_Name: this.state.lasname.toUpperCase()
        }
      })
      .then(response => {
        this.autofill(response.data[0]);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  //This function handles posting a new user to the empprofile servie and the login service.
  componentWillUnmount() {
    store.dispatch(loginhandler("logout"));
  }
  componentWillMount() {
    store.dispatch(loginhandler("login"));
  }
  signup() {
    var profileurl = "http://23.31.37.220:8080/empprofile";
    //console.log('posting to '+profileurl);
    axios
      .post(profileurl, {
        empnumber: this.state.empnumber,
        firstname: this.state.firstname,
        lastname: this.state.lasname,
        email: this.state.email,
        password: this.state.password,
        supervisor: this.state.supervisor,
        issupervisor: this.state.superstatus,
        discipline: this.state.discipline,
        profession: this.state.profession,
        homenumber: this.state.homenum,
        worknumber: this.state.worknum,
        cellnumber: this.state.cellnum,
        account: this.state.account,
        address: this.state.address,
        midddleinit: this.state.middleinit
      })
      .then(console.log("postal success"));
    axios
      .post("http://23.31.37.220:8080/login", {
        email: this.state.email,
        password: this.state.password,
        empnumber: this.state.empnumber
      })
      .then(this.setState({ modalOpen: true }));
  }
  /* This function handles Supervisor Status */
  handleSuper() {
    var newstatus = !this.state.superstatus;
    this.setState({ superstatus: newstatus });
    if (newstatus === true) {
      this.setState({ supercheck: " " });
    } else {
      this.setState({ supercheck: " not " });
    }
    console.log("supervisor status " + newstatus);
  }
  /* This Function handles some of the autofill data*/
  autofill(data) {
    this.setState({
      empnumber: data.Emp_Nbr,

      email: data.Work_Email,
      city: data.City,
      address: data.Street_Address,
      state: data.State,
      zipcode: data.Zip,
      middleinit: data.M_Init
    });
    console.log(this.state.empnumber);
  }

  handlePassChange = e => {
    var newvalue = e.target.value;
    this.setState({ password: newvalue });
  };
  handleclose = () => {
    this.setState({ modalOpen: false });
    hashHistory.push("/");
  };
  render() {
    var toggletitle = "This User is" + this.state.supercheck + "a Supervisor";
    const genders = [
      {
        key: "m",
        text: "Male",
        value: "male"
      },
      {
        key: "f",
        text: "Female",
        value: "female"
      },
      {
        key: "o",
        text: "Other",
        value: "other"
      }
    ];
    const accountTypes = [
      {
        key: "u",
        text: "User",
        value: 1
      },
      {
        key: "h",
        text: "HR",
        value: 2
      },
      {
        key: "l",
        text: "LaborSystemAdmin",
        value: 3
      }
    ];
    const supers = [
      {
        key: "jt",
        text: "Jonathan Taylor",
        value: 524
      },
      {
        key: "bs",
        text: "Becky Staufer",
        value: 139
      },
      {
        key: "bp",
        text: "Brian Phagan",
        value: 118
      },
      {
        key: "wc",
        text: "Wesley Carter",
        value: 520
      },
      {
        key: "dq",
        text: "Dan Quiggle",
        value: 119
      },
      {
        key: "cm",
        text: "Camille McLean",
        value: 420
      }
    ];
    const job = [
      {
        key: "engr",
        text: "Engineer",
        value: "engineer"
      },
      {
        key: "design",
        text: "Designer",
        value: "design"
      },
      {
        key: "hr",
        text: "Hr/Accounting",
        value: "hr"
      },
      {
        key: "labor",
        text: "Laborer",
        value: "labor"
      },
      {
        key: "draft",
        text: "Drafter",
        value: "drafter"
      },
      {
        key: "pm",
        text: "Project Manager",
        value: "projectmanager"
      },
      {
        key: "tech",
        text: "Technician",
        value: "technician"
      }
    ];
    const field = [
      {
        key: "mech",
        text: "Mechanical",
        value: "mechanical"
      },
      {
        key: "elect",
        text: "Electrical",
        value: "electrical"
      },
      {
        key: "struct",
        text: "Structural",
        value: "structural"
      },
      {
        key: "const",
        text: "Construction",
        value: "construction"
      },
      {
        key: "acc",
        text: "Accounting",
        value: "accounting"
      }
    ];
    const emaildomains = [
      {
        key: "edf",
        text: "@edfinc.com",
        value: "@edfinc.com"
      },
      {
        key: "pwps",
        text: "@pwps.com",
        value: "@pwps.com"
      },
      {
        key: "gmail",
        text: "@gmail.com",
        value: "@gmail.com"
      }
    ];
    return (
      <div>
        <Modal
          open={this.state.modalOpen}
          onClose={() => this.handleclose()}
          basic
          size="small"
        >
          <Header icon="smile" content="Welcome" />
          <Modal.Content>
            <h3>You have successfully registered with EDF</h3>
          </Modal.Content>
          <Modal.Actions>
            <Button color="green" onClick={() => this.handleclose()} inverted>
              <Icon name="checkmark" /> Got it
            </Button>
          </Modal.Actions>
        </Modal>
        <Form>
          <Form.Group>
            <Form.Input
              label="First name"
              placeholder="First name"
              onChange={e => this.setState({ firstname: e.target.value })}
            />
            <Form.Input
              label="Last name"
              placeholder="Last name"
              onChange={e => this.setState({ lasname: e.target.value })}
              onBlur={() => this.grabInfo()}
            />
            <Form.Select
              label="Gender"
              options={genders}
              placeholder="Gender"
              onChange={(e, { value }) => this.setState({ gender: value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <label>Cell Number</label>
              <NumberFormat
                format="(###)-###-####"
                onChange={e => this.setState({ cellnum: e.target.value })}
              />
            </Form.Field>
            <Form.Field>
              <label>Home Number</label>
              <NumberFormat
                format="(###)-###-####"
                onChange={e => this.setState({ homenum: e.target.value })}
              />
            </Form.Field>
            <Form.Field>
              <label>Work Number</label>
              <NumberFormat
                format="(###)-###-####"
                onChange={e => this.setState({ worknum: e.target.value })}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Select
              label="Account Type"
              options={accountTypes}
              placeholder="Account"
              onChange={(e, { value }) => this.setState({ account: value })}
            />
            <Form.Select
              label="Supervisor"
              options={supers}
              placeholder="Supervisor"
              onChange={(e, { value }) => this.setState({ supervisor: value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <label>Profession</label>
              <Dropdown
                placeholder="Profession"
                fluid
                multiple
                selection
                options={job}
                onChange={(e, { value }) =>
                  this.setState({ profession: value })
                }
              />
            </Form.Field>
            <Form.Field>
              <label>Field</label>
              <Dropdown
                placeholder="Field"
                id="fieldinput"
                fluid
                multiple
                selection
                options={field}
                onChange={(e, { value }) =>
                  this.setState({ discipline: value })
                }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.TextArea
              id="address"
              label="Address"
              placeholder="Please Type Your Address"
              value={this.state.address}
              onChange={e => this.setState({ address: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Input
              label="City"
              value={this.state.city}
              placeholder="City"
              onChange={e => this.setState({ city: e.target.value })}
            />

            <Form.Input
              label="State"
              value={this.state.state}
              placeholder="US"
              onChange={e => this.setState({ state: e.target.value })}
            />

            <Form.Input
              label="Zipcode"
              value={this.state.zipcode}
              placeholder="#####"
              onChange={e => this.setState({ zipcode: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <label>Email</label>
              <Input
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
                labelPosition="right"
                placeholder="jsmith"
              />
            </Form.Field>

            <Form.Input
              label="Password"
              placeholder="Password"
              type="password"
              onChange={e => this.setState({ password: e.target.value })}
            />
          </Form.Group>
          <Form.Checkbox
            slider
            label={toggletitle}
            onChange={() => this.handleSuper()}
          />
        </Form>{" "}
        <Button id="submitbutton" onClick={() => this.signup()}>
          {" "}
          Submit{" "}
        </Button>
      </div>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/containers/NewUser.js